import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StaticResourcesService} from './shared/services/static-resources.service';
import {DOCUMENT} from '@angular/common';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    public router: Router,
    private staticResourcesService: StaticResourcesService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit(): void {
    this.fetchDynamicStyles();
    this.refreshPageIfIdle(300);
  }

  private refreshPageIfIdle(idleDurationSec) {
    const redirectUrl = environment.API_URL + 'saml/logout?local=true';
    let idleTimeout;
    const resetIdleTimeout = function () {
      if (idleTimeout) clearTimeout(idleTimeout);
      idleTimeout = setTimeout(() => location.href = redirectUrl, idleDurationSec * 1000);
    };
    resetIdleTimeout();
    ['click', 'touchstart', 'mousemove'].forEach(evt =>
      document.addEventListener(evt, resetIdleTimeout, false)
    );
  }

  fetchDynamicStyles() {

    const headEl = this.document.getElementsByTagName("head")[0];

    const newLinkEl = this.document.createElement("link");

    newLinkEl.rel = "stylesheet";

    const cssURL = environment.API_URL + "rest/resources/style"; //API where CSS dynamic rules are found
    newLinkEl.href = `${cssURL}`;

    headEl.appendChild(newLinkEl);

  }
}
